import { CommunityType } from './types';

export const getCommunityTranslationKey = (communityType: string | undefined): string => {
  if (!communityType || typeof communityType !== 'string') {
    return 'companyStore';
  }

  const translationKeys: { [key: string]: string } = {
    [CommunityType.HomeOfficeStore]: 'homeOfficeStore',
    [CommunityType.ChooseYourOwnDeviceStore]: 'cyodStore',
    [CommunityType.ChristmasStore]: 'christmasStore',
    [CommunityType.BackToSchoolStore]: 'backToSchoolStore',
    [CommunityType.GiftStore]: 'giftStore',
    [CommunityType.VitalityStore]: 'vitalityStore',
    [CommunityType.DigisprongStore]: 'digisprongStore',
    [CommunityType.PurchasingPortal]: 'purchasingPortal',
    [CommunityType.BlueBuiltStore]: 'blueBuiltStore',
    [CommunityType.BringYourOwnDeviceStore]: 'byodStore',
    [CommunityType.Cafetariaplan]: 'cafetariaplan',
    [CommunityType.CafetariaplanAnonymous]: 'cafetariaplan'
  };

  return translationKeys[communityType] || 'companyStore';
};
